import {
  BuildContainerObject,
  ParseCartItemForContainer,
  CurrencyConverter,
  formatCollectionName,
} from "./container-utils.js";

class CartItemSummary extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const mainContentDiv = this.querySelector("#main");
    this.mainContentDiv = mainContentDiv;

    const lineItemsHTML = this.querySelector("#items")?.innerHTML;
    let cartData;
    try {
      cartData = JSON.parse(lineItemsHTML);
      this.lineItems = JSON.parse(lineItemsHTML).lineItems;
    } catch (e) {
      console.error("Error when parsing data from cart: ", e);
    }
    this.currencyCode = CurrencyConverter(cartData.currencyCode ?? "");
    this.isLoggedIn = cartData.isLoggedIn;
    const containerObject = BuildContainerObject(
      this.currencyCode,
      this.lineItems,
      ParseCartItemForContainer
    );
    this.containerObject = containerObject ?? {};
    this.buildItemTable();
  }

  buildItemTable() {
    Object.entries(this.containerObject)?.map(
      ([collectionName, collectionContainerObject], _) => {
        const formattedCollectionName = formatCollectionName(collectionName);

        this.mainContentDiv.insertAdjacentElement(
          "beforeend",
          new SingleContainerItemSummary(
            formattedCollectionName,
            collectionContainerObject,
            this.isLoggedIn
          ).create()
        );
      }
    );
  }
}

class SingleContainerItemSummary {
  constructor(collectionName, collectionContainerObject, isLoggedIn) {
    this.collectionName = collectionName;
    this.collectionContainerObject = collectionContainerObject;
    this.isLoggedIn = isLoggedIn;

    this.singleItemSummaryElement = document.createElement("div");
    this.singleItemSummaryElement.classList.add("single-summary");
  }

  create() {
    this.createHeader();
    this.createSingleSummaryTable();

    this.createTableRows();
    return this.singleItemSummaryElement;
  }

  createHeader() {
    this.singleItemSummaryElement.insertAdjacentHTML(
      "afterbegin",
      `<div class="single-summary__header">
            <h3 class="collection-name">
              Collection: ${this.collectionName}
            </h3>
        </div>`
    );
  }

  createSingleSummaryTable() {
    const singleSummaryTable = document.createElement("table");
    singleSummaryTable.classList.add("single-summary-table");
    this.singleItemSummaryElement.insertAdjacentElement(
      "beforeend",
      singleSummaryTable
    );

    // install table head
    singleSummaryTable.insertAdjacentHTML(
      "afterbegin",
      `
      <thead>
        <tr>
          <th>
            <div>No.</div>
          </th>
          <th>
            <div>Code</div>
          </th>
          <th>
            <div>Picture</div>
          </th>
          <th>
            <div>Unit</div>
          </th>
          <th>
            <div>
              <span>Pot Sizes</span>
            </div>
          </th>
         
          <th>Color Pictures</th>
          <th>Color Name</th>
           ${this.isLoggedIn ? `<th>Unit price</th>` : ""}
          <th>
            <div>Quantity</div>
          </th>
          ${this.isLoggedIn ? `<th>Total</th>` : ""}
          <th>No. of Pallets</th>
        </tr>
      </thead>
      `
    );

    const singleSummaryTableBody = document.createElement("tbody");
    singleSummaryTable.insertAdjacentElement(
      "beforeend",
      singleSummaryTableBody
    );

    this.singleSummaryTable = singleSummaryTable;
    this.singleSummaryTableBody = singleSummaryTableBody;
  }

  createTableRows() {
    this.collectionContainerObject?.containerList?.map((singleContainer, _) => {
      Object.entries(singleContainer?.itemList)?.map(
        ([itemID, item], itemIndex) => {
          const tableRow = document.createElement("tr");
          const colorsCode = Object.keys(item.colors);
          const colorsNum = colorsCode.length;
          const firstColor = Object.values(item.colors)[0];
          const sizesInSet = item.sizesInSet
            ?.map(
              (size, index) => `<p>
                 ${String.fromCharCode(65 + index)}. ${size}</p>`
            )
            .join("");
          // insert inital data cells
          tableRow.insertAdjacentHTML(
            "afterbegin",
            `
              <td rowspan="${colorsNum}">${itemIndex + 1}</td>
              <td rowspan="${colorsNum}">${item.sku}</td>
              <td rowspan="${colorsNum}">
                <img
                  src="${item.image}"
                  alt="${item.sku} Product Image"
                  class="product-image"
                />
              </td>
              <td rowspan="${colorsNum}">S${item.sizesInSet.length}</td>
              <td rowspan="${colorsNum}">${sizesInSet}</td>
              <td>
              <div class="wrapper">
              <img src="${firstColor.colorImage}" alt="${
              firstColor.colorName
            }" class="color-image"/>
            </div></td>
              <td>${colorsCode[0]} - ${firstColor.colorName}</td>

              ${
                this.isLoggedIn
                  ? `<td>$${firstColor.cost.toLocaleString()}</td>`
                  : ""
              }
              <td>${firstColor.quantity} sets</td>
              ${
                this.isLoggedIn
                  ? `<td>$${(
                      firstColor.cost * firstColor.quantity
                    ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>`
                  : ""
              }
              <td rowspan="${colorsNum}">${item.numberOfPallets?.toFixed(
              2
            )} pallets</td>
              `
          );

          // insert row into table body
          this.singleSummaryTableBody.insertAdjacentElement(
            "beforeend",
            tableRow
          );

          Object.entries(item.colors)?.forEach(
            ([colorCode, colorObject], index) => {
              if (index > 0) {
                const colorRow = document.createElement("tr");
                const [
                  costPerQuantityDataElement,
                  colorImageDataElement,
                  colorInfoDataElement,
                  colorQuantityDataElement,
                  colorCostDataElement,
                ] = new ItemSummaryColorData(
                  colorCode,
                  colorObject,
                  this.collectionContainerObject.currencyCode
                ).create();
                colorRow.insertAdjacentElement(
                  "beforeend",
                  colorImageDataElement
                );
                colorRow.insertAdjacentElement(
                  "beforeend",
                  colorInfoDataElement
                );
                if (this.isLoggedIn) {
                  colorRow.insertAdjacentElement(
                    "beforeend",
                    costPerQuantityDataElement
                  );
                }
                colorRow.insertAdjacentElement(
                  "beforeend",
                  colorQuantityDataElement
                );

                if (this.isLoggedIn) {
                  colorRow.insertAdjacentElement(
                    "beforeend",
                    colorCostDataElement
                  );
                }
                this.singleSummaryTableBody.insertAdjacentElement(
                  "beforeend",
                  colorRow
                );
              }
            }
          );

          // tableRow.insertAdjacentHTML(
          //   "beforeend",
          //   `
          //   <td>
          //     <span>See more</span>
          //   </td>
          //   `,
          // );
        }
      );
    });
  }
}

class ItemSummaryColorData {
  constructor(colorCode, item, currencyCode) {
    this.item = item;
    this.currency = currencyCode;
    this.colorCode = colorCode;

    this.costPerQuantityDataElement = this.createDataAndWrapper();
    this.colorImageDataElement = this.createDataAndWrapper();
    this.colorInfoDataElement = this.createDataAndWrapper();
    this.colorQuantityDataElement = this.createDataAndWrapper();
    this.colorCostDataElement = this.createDataAndWrapper();

    this.initColorData();
  }

  initColorData() {
    const colorObject = this.item;
    this.colorImage = colorObject.colorImage ?? "";
    this.colorInfo = {
      colorCode: this.colorCode,
      colorName: colorObject.colorName,
      extraPercentage: colorObject.extraPercentage,
    };
    this.colorQuantity = colorObject.quantity ?? 0;
    this.colorCost = colorObject.cost ?? 0;
  }

  create() {
    this.insertCostAmountPerQuantityData();
    this.insertColorImageData();
    this.insertColorInfoData();
    this.insertColorQuantity();
    this.insertColorCost();

    return [
      this.costPerQuantityDataElement,
      this.colorImageDataElement,
      this.colorInfoDataElement,
      this.colorQuantityDataElement,
      this.colorCostDataElement,
    ];
  }

  createDataAndWrapper() {
    const tableData = document.createElement("td");
    tableData.insertAdjacentHTML("afterbegin", `<div class="wrapper"></div>`);

    return tableData;
  }

  getWrapperFromTableData(element) {
    return element.querySelector(".wrapper");
  }

  insertCostAmountPerQuantityData() {
    const wrapper = this.getWrapperFromTableData(
      this.costPerQuantityDataElement
    );

    const contentElement = document.createElement("p");
    contentElement.innerHTML = `${this.currency}${this.item?.cost}`;

    wrapper.insertAdjacentElement("beforeend", contentElement);
  }

  insertColorImageData() {
    const wrapper = this.getWrapperFromTableData(this.colorImageDataElement);

    if (this.colorImage) {
      wrapper.insertAdjacentHTML(
        "beforeend",
        `
          <img
            src="${this.colorImage}"
            alt="Image of a color"
            class="color-image"
          />
        `
      );
    }
  }

  insertColorInfoData() {
    const wrapper = this.getWrapperFromTableData(this.colorInfoDataElement);

    if (!this.colorInfo) return;
    wrapper.insertAdjacentHTML(
      "beforeend",
      `
          <p>
            ${this.colorInfo.colorCode} - ${this.colorInfo.colorName}
            ${
              this.colorInfo.extraPercentage > 0
                ? `<span class="">+ ${this.colorInfo.extraPercentage}%</span>`
                : ""
            }
          </p>
        `
    );
  }

  insertColorQuantity() {
    const wrapper = this.getWrapperFromTableData(this.colorQuantityDataElement);
    if (!this.colorQuantity) return;
    wrapper.insertAdjacentHTML(
      "beforeend",
      `
        <p>${this.colorQuantity} sets</p>
        `
    );
  }

  insertColorCost() {
    const wrapper = this.getWrapperFromTableData(this.colorCostDataElement);
    if (!this.colorCost) return;
    wrapper.insertAdjacentHTML(
      "beforeend",
      `
        <p class="">
          ${this.currency}${(this.colorCost * this.colorQuantity)
        .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </p>
        `
    );
  }
}

customElements.define("cart-item-summary", CartItemSummary);
